/**
 * The only analytics the browser sends: the few events the server can't see itself.
 * Event names + small properties only (see apps/api/src/services/analytics.ts). No third-party tracker.
 */
type ClientEvent = { event: "signup_started" } | { event: "setup_abandoned"; properties: { step: string } };

const BASE = import.meta.env.VITE_API_URL ?? "";

export function emit(e: ClientEvent): void {
  const body = JSON.stringify(e);
  try {
    // sendBeacon survives page unload (needed for "abandoned"); fall back to fetch.
    if (navigator.sendBeacon?.(`${BASE}/api/analytics/event`, body)) return;
  } catch {
    /* fall through */
  }
  void fetch(`${BASE}/api/analytics/event`, { method: "POST", credentials: "include", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => {});
}
